import { Paper } from '@mantine/core';

import AddressForm, { AddressFormData } from '../../../components/AddressForm';

import styles from './AddressFormMenu.module.scss';

interface Props {
  isOpen: boolean;
  practitionerId: string;
  addressId?: string;
  initialData?: Partial<AddressFormData>;
  onSave: () => void;
  onClose: () => void;
}

const AddressFormMenu = ({ isOpen, practitionerId, addressId, initialData, onSave, onClose }: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className={styles.overlay} />
      <Paper
        classNames={{
          root: styles.menu,
        }}
      >
        <AddressForm
          displayQuickFill={true}
          practitionerId={practitionerId}
          addressId={addressId}
          initialForm={initialData}
          onSave={onSave}
          onClose={onClose}
        />
      </Paper>
    </>
  );
}

export default AddressFormMenu;
